import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static COLORS = [
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#96CEB4",
    "#FFEAA7",
    "#DDA0DD",
    "#98D8C8",
  ];

  connect() {
    this._spawnConfetti();
  }

  close() {
    this.element.close();
    this.element.remove();
  }

  // Private

  _spawnConfetti() {
    const count = 80;
    const container = document.createElement("div");
    container.className = "fixed inset-0 pointer-events-none z-50";

    for (let i = 0; i < count; i++) {
      const piece = document.createElement("div");
      piece.className = "confetti-piece";
      piece.style.left = `${Math.random() * 100}%`;
      piece.style.animationDelay = `${Math.random() * 0.5}s`;
      piece.style.backgroundColor = this._randomColor();
      container.appendChild(piece);
    }

    document.body.appendChild(container);
    this._container = container;
    this._timeoutId = setTimeout(() => container.remove(), 3000);
  }

  disconnect() {
    clearTimeout(this._timeoutId);
    this._container?.remove();
  }

  _randomColor() {
    const colors = this.constructor.COLORS;
    return colors[Math.floor(Math.random() * colors.length)];
  }
}
